<template>
    <div class="card">
        <img :src="item.icon_path" class="card-img-top">
        <div class="card-body">
            <h5 class="program-title">{{ this.$i18n.locale == 'ar' ? item.name : item.name_en }}</h5>
            <p class="program-code">{{ item.code }}</p>
            <div class="row">
                <div class="col-6 d-flex align-items-center justify-content-start">
                    <img class="details_icon ms-2" src="@/assets/images/home/quranprograms/calendar.png" alt="">
                    <div :class="(this.$i18n.locale === 'ar' ? 'text-end' : 'text-start')">
                        <span class="details_title d-block">{{ $t('home.quran_programs.start_date') }}</span>
                        <span class="details_value"> {{ convertToHijri(item.h_register_start_date)
                            }}</span>
                    </div>
                </div>
                <div class="col-6 d-flex align-items-center justify-content-start">
                    <img class="details_icon ms-2" src="@/assets/images/home/quranprograms/users.png" alt="">
                    <div :class="(this.$i18n.locale === 'ar' ? 'text-end' : 'text-start')">
                        <span class="details_title d-block">{{ $t('home.quran_programs.participants_def') }}</span>
                        <span class="details_value">{{ item.students.length }} {{ item.students.length == 1 ?
                            $t('home.quran_programs.participant') :
                            $t('home.quran_programs.participants') }}</span>
                    </div>
                </div>
            </div>

            <router-link :to="{
                name: 'quran_program',
                params: {
                    id: item.id
                }
            }" class="details-btn mt-3">{{ $t('home.quran_programs.details') }}</router-link>
            <router-link to="/dashboard/#/register-programs/quran" class="subscribe-btn mt-1"> {{
                $t('home.quran_programs.start_now') }}</router-link>

        </div>
    </div>
</template>

<script>
import moment from "moment-hijri";

export default {
    props: ['item'],
    methods: {
        convertToHijri(date) {
            const hijriDate = moment(date, "iYYYY-iMM-iDD").format("iDD – iMMMM – iYYYY");
            return hijriDate.replace(/\d/g, (digit) => "٠١٢٣٤٥٦٧٨٩"[digit]);
        },
    }
}
</script>

<style scoped>
.card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.card-img-top {
    height: 180px;
    object-fit: cover;
}

.card-body {
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
}

.program-title {
    font-size: 20px;
    font-weight: bold;
    color: #393735;
}

.program-code {
    font-size: 18px;
    font-weight: 400;
    color: #A09F9E;
}


.subscribe-btn {
    background-color: #BF9F35;
    color: white;
    font-weight: bold;
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-size: 20px;
    font-weight: 500;
    margin-top: auto;
}

.subscribe-btn:hover {
    background-color: #a17c3a;
    color: white;
}


.details_title {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 10px;
    color: #3937357A;
}

.details_value {
    font-size: 14px;
    font-weight: 500;
    color: #393735;
    position: relative;
    bottom: 10px;
    min-height: 24px;
}

.details-btn {
    background-color: #F2F2F2;
    color: #393735;
    font-weight: bold;
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    text-decoration: none;
    display: block;
    font-size: 20px;
    font-weight: 500;
}
</style>